<div class="event-branding-container">

    <!-- Header — skipped when embedded in Manage Event, whose own panel
         header already shows "Event Branding" with a close (X); rendering
         both just duplicated the title. -->
    <div class="create-event-header" *ngIf="!hideHeader">
        <div class="back-div">
            <button class="eb-back-btn" type="button" (click)="goBack()" aria-label="Back">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <h1 class="eb-title">Event Branding</h1>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="eb-loading">
        <span class="eb-spinner"></span>
    </div>

    <!-- Form Content -->
    <div class="eb-content" *ngIf="!isLoading">

        <!-- Branding Toggle - Host Only -->
        <div class="eb-section" [formGroup]="brandingForm" *ngIf="isHost === true || isHost === 'true'">
            <div class="eb-row eb-row--toggle">
                <div class="eb-row-text">
                    <span class="eb-row-label">Show Branding on Gallery</span>
                    <span class="eb-row-sublabel">Enable to display your branding information on the event gallery page</span>
                </div>
                <label class="eb-switch" [class.eb-switch--disabled]="!isEditable">
                    <input type="checkbox" formControlName="isActive" [disabled]="!isEditable" (change)="onToggleChange()">
                    <span class="eb-switch-thumb"></span>
                </label>
            </div>

            <!-- Edit lives in-content, not the header, so it works the same
                 way whether this component owns the page or is embedded. -->
            <div class="eb-row-divider" *ngIf="!isEditable && brandingForm.get('isActive')?.value"></div>
            <div class="eb-row eb-row--edit" *ngIf="!isEditable && brandingForm.get('isActive')?.value">
                <button type="button" class="eb-edit-link" (click)="toggleEdit()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Edit
                </button>
            </div>
        </div>

        <form class="eb-form" [formGroup]="brandingForm" (ngSubmit)="saveBranding()" *ngIf="brandingForm.get('isActive')?.value">

            <!-- Brand Name -->
            <div class="eb-form-group">
                <label class="eb-form-label">Brand Name <span class="eb-required">*</span></label>
                <input class="eb-form-input" formControlName="brandName" type="text" placeholder="Enter brand name" maxlength="100"
                    [readonly]="!isEditable" required />
                <div class="eb-form-meta">
                    <span class="eb-char-count">{{ formControls['brandName'].value?.length || 0 }}/100 characters</span>
                </div>
                <div *ngIf="formControls['brandName'].touched && formControls['brandName'].invalid" class="eb-form-error">
                    <p *ngIf="formControls['brandName'].errors?.['required']">Brand Name is required.</p>
                    <p *ngIf="formControls['brandName'].errors?.['maxlength']">Brand Name cannot exceed 100 characters.</p>
                </div>
            </div>

            <!-- Logo Upload -->
            <div class="eb-form-group">
                <label class="eb-form-label">Brand Logo</label>
                <div class="eb-logo-row">
                    <input type="file" id="logoInput" accept="image/*" [disabled]="!isEditable"
                        (change)="onLogoSelected($event)" style="display: none;" />
                    <button type="button" class="eb-upload-btn" [disabled]="!isEditable" (click)="triggerFileInput()">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        {{ logoUrl ? 'Change Logo' : 'Upload Logo' }}
                    </button>

                    <div class="eb-logo-preview" *ngIf="logoUrl">
                        <img [src]="logoUrl" alt="Brand Logo">
                        <button type="button" class="eb-remove-logo" [disabled]="!isEditable" (click)="removeLogo()" aria-label="Remove logo">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <span class="eb-hint">Recommended size: 500x500px, Max: 2MB</span>
            </div>

            <!-- Facebook Link -->
            <div class="eb-form-group">
                <label class="eb-form-label">Facebook Page</label>
                <input class="eb-form-input" formControlName="facebookLink" type="url" placeholder="https://facebook.com/yourpage"
                    [readonly]="!isEditable" />
                <div *ngIf="formControls['facebookLink'].touched && formControls['facebookLink'].invalid" class="eb-form-error">
                    <p>Please enter a valid Facebook URL.</p>
                </div>
            </div>

            <!-- Instagram Link -->
            <div class="eb-form-group">
                <label class="eb-form-label">Instagram Profile</label>
                <input class="eb-form-input" formControlName="instagramLink" type="url"
                    placeholder="https://instagram.com/yourprofile" [readonly]="!isEditable" />
                <div *ngIf="formControls['instagramLink'].touched && formControls['instagramLink'].invalid" class="eb-form-error">
                    <p>Please enter a valid Instagram URL.</p>
                </div>
            </div>

            <!-- Website Link -->
            <div class="eb-form-group">
                <label class="eb-form-label">Website</label>
                <input class="eb-form-input" formControlName="websiteLink" type="url" placeholder="https://www.yourwebsite.com"
                    [readonly]="!isEditable" />
                <div *ngIf="formControls['websiteLink'].touched && formControls['websiteLink'].invalid" class="eb-form-error">
                    <p>Please enter a valid website URL.</p>
                </div>
            </div>

            <!-- Phone Number -->
            <div class="eb-form-group">
                <label class="eb-form-label">Contact Phone</label>
                <input class="eb-form-input" formControlName="phoneNumber" type="tel" placeholder="+1 (555) 123-4567"
                    [readonly]="!isEditable" />
                <div *ngIf="formControls['phoneNumber'].touched && formControls['phoneNumber'].invalid" class="eb-form-error">
                    <p>Please enter a valid phone number.</p>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="eb-form-actions" *ngIf="isEditable">
                <button type="button" class="eb-btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
                    Cancel
                </button>
                <button type="submit" class="eb-btn-save" [disabled]="isLoading || brandingForm.invalid">
                    <span *ngIf="!isLoading">Save Changes</span>
                    <span *ngIf="isLoading" class="eb-btn-spinner"></span>
                </button>
            </div>
        </form>
    </div>
</div>
